module.exports = __webpack_public_path__ + "static/media/Languages.ea358519.cjs";